import { Component } from '@angular/core';
import { RegisterComponent } from './register/register.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-onboard-meter',
  template: `
    <app-registration
      [onboardMeter]="true"
      [tpi]="isTpi"
      [email]="email"
    ></app-registration>
  `,
  styles: [],
  imports: [RegisterComponent],
})
export class OnboardMeterComponent {
  isTpi: boolean = false;
  email?: string;
  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParams.subscribe(async (params) => {
      this.isTpi = params['tpi'] === 'true';
      this.email = params['email'];
    });
  }
}
